module.exports = __webpack_public_path__ + "static/media/50-iveco-mercedes.de279604.jpg";